import type { ReactNode } from 'react';
import type { FeatureFlags } from '@noths/polaris-client-feature-flags';

export enum LayoutTypes {
  GLOBAL_COMPONENTS,
  MINIMAL,
  CLIENT_SITE_CHROME_UI,
}

interface BaseLayoutComponentProps {
  children?: ReactNode;
  navData?: unknown;
  topBannerData?: unknown;
}

export interface LayoutComponentProps extends BaseLayoutComponentProps {
  NODE_ENV: string;
}

export interface SiteChromeLayoutComponentProps extends BaseLayoutComponentProps {
  featureFlags?: FeatureFlags;
  isProdLikeEnv: boolean;
  mergeBasket?: boolean;
  searchedTerm?: string;
  siteChromeCompactMode?: boolean;
}

export type Scripts = string[];
